// Central demo clock and calendar (mock data lot, 13/10). EVERY date reference of the fixtures and of the few render spots that
// need « today » derives from here, instead of scattered literals. FICTITIOUS demo context, no real data: the member lives on
// Monday 12 October 2026, 16:00, in the week of 12–18 October. Done records are all at or before this instant; anything later
// is a plan, a booking or an announced event, never a completion.
export const DEMO_TODAY = "2026-10-12";          // ISO date of the demo « today »
export const DEMO_TIME = "16:00";                // demo « now » (end of the afternoon)
export const DEMO_NOW = `${DEMO_TODAY}T${DEMO_TIME}`;
export const DEMO_MONDAY = "2026-10-12";         // first day of the current week
export const DEMO_TODAY_KEY = "d12";             // day key of the home / planning convention (d12 … d18)
export const DEMO_MONDAY_KEY = "d12";

/** « lundi 12 octobre » (fr-FR, long) for an ISO date. */
export const longDay = (iso: string) => new Date(`${iso}T12:00:00`).toLocaleDateString("fr-FR", { weekday: "long", day: "numeric", month: "long" });
export const capitalize = (s: string) => s.charAt(0).toUpperCase() + s.slice(1);
